/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InitiatePaymentRequestDto } from '../models/InitiatePaymentRequestDto';
import type { InitiatePaymentResponseDto } from '../models/InitiatePaymentResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentControllerService {
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static handleWebhook(): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payments/webhook',
        });
    }
    /**
     * @param requestBody
     * @returns InitiatePaymentResponseDto OK
     * @throws ApiError
     */
    public static initiatePayment(
        requestBody: InitiatePaymentRequestDto,
    ): CancelablePromise<InitiatePaymentResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payments/initiate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
